import { render, staticRenderFns } from "./NotifGapSMS.vue?vue&type=template&id=31c59e1f&"
import script from "./NotifGapSMS.vue?vue&type=script&lang=ts&"
export * from "./NotifGapSMS.vue?vue&type=script&lang=ts&"
import style0 from "./NotifGapSMS.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports